export var NavbarItemMarkup;
(function (NavbarItemMarkup) {
    NavbarItemMarkup["DIV"] = "div";
    NavbarItemMarkup["A"] = "a";
    NavbarItemMarkup["P"] = "p";
    NavbarItemMarkup["SPAN"] = "span";
})(NavbarItemMarkup || (NavbarItemMarkup = {}));
//# sourceMappingURL=NavbarItemEnum.js.map